<template>
  <el-dialog
    :visible="value"
    title="发送短信"
    width="600px"
    @close="onClose"
  >
    <v-schema-form
      v-model="form"
      :effects="effects"
      :schema="schema"
    />
    <div slot="footer">
      <el-button
        :disabled="loading"
        @click="cancel"
      >
        取消
      </el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="send"
      >
        发送
      </el-button>
    </div>
  </el-dialog>
</template>
<script type="text/babel">
import { api } from '@/plugins/api';

export default {
  name: 'SmsDialog',
  props: {
    value: { type: Boolean, required: true },
    accidentId: { type: String, required: true },
    parties: { type: Array, required: true },
  },
  data() {
    return {
      form: {},
      loading: false,
      schema: {
        props: {
          labelWidth: '90px',
        },
        fields: {
          phone: {
            title: '当事人',
            required: true,
            type: 'select',
          },
          type: {
            title: '短信类型',
            type: 'select',
            defaultValue: 0,
            required: true,
            enum: [
              {
                label: '自定义',
                value: 0,
              },
              {
                label: '拖车',
                value: 1,
              },
              {
                label: '修车',
                value: 2,
              },
            ],
          },
          content: {
            title: '短信内容',
            type: 'text',
            required: true,
            props: {
              rows: 8,
            },
          },
        },
      },
    };
  },
  methods: {
    effects($) {
      console.log(this.parties);
      $('phone').setEnum(
        this.parties.map((it) => ({
          label: it.name || it.phone,
          value: it.phone,
        }))
      );
    },
    onClose() {
      this.$emit('input', false);
    },
    cancel() {
      this.form.content = '';
      this.form.type = 0;
      this.$emit('input', false);
    },
    send() {
      this.$confirm('确定发送短信给' + this.form.phone + '吗？', '提示').then(
        async () => {
          this.form.accidentId = this.accidentId;
          try {
            this.loading = true;
            await api.accident.sms.send.r(this.form);
            this.$message.success('发送成功');
            this.$emit('input', false);
          } catch (e) {
            console.log(e);
          } finally {
            this.loading = false;
          }
        }
      );
    },
  },
};
</script>
<style lang="less" type="text/less">
</style>
